export default {
    name: 'v5-icon-praise-fill',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M710.55 384.81a12409.045 12409.045 0 0047.466-.32l8.747-.085c83.989-.618 141.44 67.584 126.72 150.23l-46.187 259.392c-10.027 56.448-63.915 101.546-121.13 101.589L298.623 896a42.73 42.73 0 01-42.667-42.41l-.81-383.98a42.667 42.667 0 0142.026-42.666l3.158-.064c5.226-.043 11.797-.043 19.626 0 91.947.768 170.88-86.699 170.71-170.944-.15-86.741 39.786-126.763 106.453-127.573 62.25-.747 106.603 59.605 107.35 149.12.213 26.602-6.294 73.237-14.507 107.434 6.186 0 13.077-.042 20.586-.085zm-497.707 63.233l.49 426.581A21.312 21.312 0 01191.787 896h-42.262A21.333 21.333 0 01128 874.624l.043-426.581a21.27 21.27 0 0121.397-21.376h41.984c11.67 0 21.419 9.578 21.419 21.376z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
